import { combineReducers } from 'redux';
import { UPDATE_STAGING_BASIC } from './constants';
import storage from 'redux-persist/lib/storage/session';
import { persistReducer } from 'redux-persist';

/*
 * State shape
 {
    basic: '',
 }
*/

const basic = (state = '', action) => {
    switch (action.type) {
        case UPDATE_STAGING_BASIC:
            return action.credentials;
        default:
            return state;
    }
};

// Persist only token
const stagingBasicPersist = {
    key: 'staging.basic',
    storage: storage
};

export default persistReducer(stagingBasicPersist, combineReducers({ basic }));



// WEBPACK FOOTER //
// ./src/services/authentication/staging/reducer.js